import { getApi, patchApi, postApi } from '../../../utils/api'

export function getFeedback(params) {
  return getApi({ endpoint: `api/ratings/`, params })
}

export function createRating(data) {
  return postApi({ data, endpoint: 'api/ratings/' })
}

export function updateRating(id, data) {
  return patchApi({ data, endpoint: `api/ratings/${id}/` })
}
